<template>
  <v-card class="elevation-0">
    <div>
      <div class="row-title-btn">
        <div class="controls-actions d-flex justify-end">
          <v-btn @click="openDialog" icon class="ml-2">
            <v-icon size="24">{{ icons.mdiPlus }}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="values"
      :loading="loading"
      item-key="name"
      class="table-rounded datatable-height elevation-3"
      fixed-header
      disable-sort
      hide-default-footer
    >
      <!-- icon -->
      <template #[`item.icon`]="{ item }">
        <div class="icon-service center-sub-items">
          <img draggable="false" :src="loadImage(item.icon)" :alt="item.moral_values" />
        </div>
      </template>
      <!-- value -->
      <template #[`item.moral_values`]="{ item }">
        <div class="d-flex flex-column">
          <span class="d-block font-weight-semibold text--primary text-truncate text-uppercase">{{ item.moral_values }}</span>
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="d-flex">
          <CrudButtons @edit="openEdit(item)" @remove="openRemove(item)"></CrudButtons>
        </div>
      </template>
    </v-data-table>
    <WDialog width="600" :dialog="dialog" :closeDialog="closeDialog" :title="titleDialog" :subtitle="subtitleDialog">
      <template v-slot:form-dialog>
        <FormValues
          v-if="dialog"
          :loading="loading"
          :valueEdited="valueEdited"
          @beforeUpdate="updateValue"
          @beforeCreate="createValue"
        ></FormValues>
      </template>
    </WDialog>
  </v-card>
</template>

<script>
import { mdiPlus } from '@mdi/js'
import CrudButtons from '@/components/buttons/CrudButtons.vue'
import FormValues from '@/components/forms/FormValues.vue'
import useValues from '@/composables/useValues'
import WDialog from '@/components/dialogs/WDialog.vue'
import { loadAPIImage } from '@/utils/images'

export default {
  components: {
    CrudButtons,
    WDialog,
    FormValues,
  },
  setup() {
    const {
      dialog,
      valueEdited,
      values,
      loading,
      // computed
      titleDialog,
      subtitleDialog,
      // methods
      openDialog,
      openEdit,
      openRemove,
      closeDialog,
      // crud
      createValue,
      updateValue,
    } = useValues()

    const loadImage = src => {
      return loadAPIImage(src)
    }

    return {
      icons: {
        mdiPlus,
      },
      dialog,
      valueEdited,
      values,
      loading,
      // computed
      titleDialog,
      subtitleDialog,
      // methods
      openDialog,
      openEdit,
      openRemove,
      closeDialog,
      loadImage,
      // crud
      createValue,
      updateValue,
      headers: [
        { text: 'ICONO', value: 'icon' },
        { text: 'VALOR', value: 'moral_values' },
        { text: 'CONTENIDO', value: 'description' },
        { text: '', value: 'actions', align: 'right' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.icon-service {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: white;
  padding: 10px;
  margin: 10px;
}

.icon-service img {
  max-width: 50px;
  max-height: 50px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>